import { ptrToString } from "./utils";

const state = {};

export function setState(b) {
  state['HEAP8'] = new Int8Array(b);
  state['HEAP16'] = new Int16Array(b);
  state['HEAPU8'] = new Uint8Array(b);
  state['HEAPU16'] = new Uint16Array(b);
  state['HEAP32'] = new Int32Array(b);
  state['HEAPU32'] = new Uint32Array(b);
  state['HEAPF32'] = new Float32Array(b);
  state['HEAPF64'] = new Float64Array(b);
  state['HEAP64'] = new BigInt64Array(b);
  state['HEAPU64'] = new BigUint64Array(b);
}

export function checkCookieValid(max) {
  if (max === 0) {
    max += 4;
  }

  const cookie1 = state['HEAPU32'][max >> 2];
  const cookie2 = state['HEAPU32'][max + 4 >> 2];

  if (cookie1 !== 0x02135467 || cookie2 !== 0x89BACDFE) {
    throw new WebAssembly.RuntimeError(`Stack overflow! Stack cookie has been overwritten at ${ptrToString(max)}, expected hex dwords 0x89BACDFE and 0x2135467, but received ${ptrToString(cookie2)} ${ptrToString(cookie1)}`);
  }

  // Also test the global address 0 for integrity.
  if (state['HEAPU32'][0 >> 2] !== 0x63736d65 /* 'emsc' */) {
    throw new WebAssembly.RuntimeError('Runtime error: The application has corrupted its heap memory area (address zero)!');
  }
}

export function setCookie(max) {
  // If the stack ends at address zero we write our cookies 4 bytes into the stack.
  // This prevents interference with SAFE_HEAP and ASAN which also monitor writes to address zero.
  if (max === 0) {
    max += 4;
  }

  // The stack grow downwards towards _emscripten_stack_get_end.
  // We write cookies to the final two words in the stack and detect if they are ever overwritten.
  state['HEAPU32'][max >> 2] = 0x02135467;
  state['HEAPU32'][max + 4 >> 2] = 0x89BACDFE;
  state['HEAPU32'][0 >> 2] = 1668509029; // Also test the global address 0 for integrity.
}

export function getValue(ptr) {
  let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'i8';
  if (type.endsWith('*')) {
    type = '*';
  }

  switch (type) {
    case 'i1':
      return state['HEAP8'][ptr];
    case 'i8':
      return state['HEAP8'][ptr];
    case 'i16':
      return state['HEAP16'][ptr >> 1];
    case 'i32':
      return state['HEAP32'][ptr >> 2];
    case 'i64':
      return state['HEAP64'][ptr >> 3];
    case 'float':
      return state['HEAPF32'][ptr >> 2];
    case 'double':
      return state['HEAPF64'][ptr >> 3];
    case '*':
      return state['HEAPU32'][ptr >> 2];
    default:
      throw new WebAssembly.RuntimeError(`invalid type for getValue: ${type}`);
  }
}

export function setValue(ptr, value) {
  let type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'i8';
  if (type.endsWith('*')) {
    type = '*';
  }

  switch (type) {
    case 'i1':
      state['HEAP8'][ptr] = value;
      break;
    case 'i8':
      state['HEAP8'][ptr] = value;
      break;
    case 'i16':
      state['HEAP16'][ptr >> 1] = value;
      break;
    case 'i32':
      state['HEAP32'][ptr >> 2] = value;
      break;
    case 'i64':
      state['HEAP64'][ptr >> 3] = BigInt(value);
      break;
    case 'float':
      state['HEAPF32'][ptr >> 2] = value;
      break;
    case 'double':
      state['HEAPF64'][ptr >> 3] = value;
      break;
    case '*':
      state['HEAPU32'][ptr >> 2] = value;
      break;
    default:
      throw new WebAssembly.RuntimeError(`invalid type for setValue: ${type}`);
  }
}

export default state;
